import { ApiError } from './ApiError';
import type { NormalizedError } from '@/types/NormalizedError';

export function toAppError(err: unknown): NormalizedError {
  if (err instanceof ApiError) {
    const msgs = err.errors();
    const validationMessages = msgs[0] != null ? (msgs as string[]) : null;

    return {
      status: err.status,
      message: err.message,
      validationMessages,
      origin: 'api',
    };
  }

  if (err instanceof Error) {
    return {
      status: 0,
      message: err.message,
      validationMessages: null,
      origin: 'unknown',
    };
  }

  return {
    status: 0,
    message: 'Unexpected error',
    validationMessages: null,
    origin: 'unknown',
  };
}
